import type { RouteParams } from 'vue-router'

import apiClient from '@shared/api'
import type IVisitDocument from '@shared/api/visits/resources/documents/visit-document'
import type ICreateDocument from '@shared/api/visits/resources/documents/create-document'
import type IDocumentPreSignedUrl from '@shared/api/visits/resources/documents/create-pre-signed-url'
import type IPatientDocument from '@shared/api/patients/resources/patients/patient-document'

export const getVisitDocumentsList = ({ visitId }: { visitId: string | string[] }): Promise<IVisitDocument[]> => {
  return apiClient.get(`/visits/${visitId}/documents`)
}

export const deleteVisitDocument = ({
  visitId,
  documentId,
}: {
  visitId: string | string[]
  documentId: string
}): Promise<unknown> => {
  return apiClient.delete(`/visits/${visitId}/documents/${documentId}`)
}

export const createDocumentPresignedUrl = ({
  visitId,
}: {
  visitId: string | string[]
}): Promise<IDocumentPreSignedUrl> => {
  return apiClient.post(`/visits/${visitId}/documents/pre-signed-url`)
}

export const createVisitDocument = ({
  visitId,
  documentData,
}: {
  visitId: string | string[]
  documentData: ICreateDocument
}): Promise<IVisitDocument> => {
  return apiClient.post(`/visits/${visitId}/documents`, documentData)
}

export const getUploadedFile = (url: string) => {
  return apiClient.get(url)
}

export const getPatientVisitDocumentList = ({
  patientId,
  communityId,
}: {
  patientId: string | string[] | RouteParams
  communityId: string | string[] | RouteParams
}): Promise<IPatientDocument[]> => {
  return apiClient.get(`/visits/patients/${patientId}/documents?communityId=${communityId}`)
}
